import { IS_E2E } from './environment';

export const TID = {
	// Login
	'login-email-input': 'login-email-input',
	'login-password-input': 'login-password-input',
	'login-organization-slug-input': 'login-organization-slug-input',
	'login-button': 'login-button',

	// Stories
	'create-story-button': 'create-story-button',
	'stories-list': 'stories-list',
	'story-item': 'story-item',
	'team-scope-item': 'team-scope-item',

	// Common
	'page-search-input': 'page-search-input',
	'modal-confirm-button': 'modal-confirm-button',

	// Create Story Modal
	'create-story-modal': 'create-story-modal',
	'create-story-name-input': 'create-story-name-input',
	'create-story-type-select': 'create-story-type-select',
	'create-story-language-select': 'create-story-language-select',
	'create-story-from-scratch-button': 'create-story-from-scratch-button',
	'create-story-submit-button': 'create-story-submit-button',

	// Story Editor
	'story-editor': 'story-editor',
	'story-title': 'story-title',
	'story-chat-open-button': 'story-chat-open-button',
	'story-chat-history-button': 'story-chat-history-button',
	'story-chat-usage-tab': 'story-chat-usage-tab',
	'story-usage-total': 'story-usage-total',
	'story-usage-breakdown': 'story-usage-breakdown',
} as const;

export type TIDValue = (typeof TID)[keyof typeof TID];

export const tid = (id: TIDValue) => (IS_E2E ? { 'data-testid': id } : null);
